import { Component } from '@angular/core';

import { ICellEditorParams, JoinAdvancedFilterModel, NumberAdvancedFilterModel } from 'ag-grid-enterprise';

import { InputChoicesComponent } from '@camelot/form-input';

import { BaseEditorComponent } from '../base-col';
import type { EnumCol } from './enum-col';

@Component({
  host: { 'data-cid': 'enum-editor' },
  imports: [InputChoicesComponent],
  selector: '',
  template: `<cam-input-choices
    [input]="$any(this.input)"
    [standalone]="true"
    [onFocus]="this.focus$"
  ></cam-input-choices>`,
})
export class EnumEditorComponent extends BaseEditorComponent<
  JoinAdvancedFilterModel | NumberAdvancedFilterModel,
  EnumCol,
  Number
> {
  override agInit(params: ICellEditorParams) {
    super.agInit(params);

    if (this.input) {
      this._registerSubscription(
        this.input.changeValue$.subscribe(() => {
          setTimeout(() => {
            this.params.api.stopEditing();
            this.params.api.tabToNextCell();
          });
        })
      );
    }
  }

  getValue() {
    return Number(this.input?.value) ?? null;
  }
}
